import { Link } from "react-router-dom";

export const MenuNav = ({ menus }) => {
  const menuList = menus.map((menu, index) => {
    let link = (
      <Link className="nav-link" to={menu[0]}>
        {menu[1]}
      </Link>
    );
    if (menu[0] === "hash") {
      link = (
        <a className="nav-link" href={"/#" + menu[1].toLowerCase()}>
          {menu[1]}
        </a>
      );
    }
    return (
      <li className="nav-item" key={index}>
        {link}
      </li>
    );
  });
  return <ul className="navbar-nav">{menuList}</ul>;
};

export const ButtonNav = ({ buttons }) => {
  const buttonList = buttons.map((button, index) => {
    return (
      <li className="nav-item" key={index}>
        {button}
      </li>
    );
  });
  return <ul className="navbar-nav ms-auto">{buttonList}</ul>;
};
